import React, { useContext } from 'react'
import { Typography, Grid, Container } from '@material-ui/core';
import '../EndOfFlowPage.scss'
import { useEffect } from 'react';
import summaryApi from '../../../api/summary.api';
import { SessionContextStore } from '../../../context/SessionContext/SessionContext';

const NotCleared = () => {

    return (
            <div className="centered-container">
                <Typography className='white bold'>Existing Policy Detected</Typography>
                <br/>
                <Typography variant='body1' className='white'>Thank you for completing your application with Skywatch.<br/> Unfortunately, our system indicates that you already have an active policy with<br/> another broker through Global Aerospace.
                </Typography>
                <br/>
                <Typography variant='body1' className='white'>We value your interest in our services,<br/> and we are here to help you navigate this situation.<br/> To proceed, please contact our support team at 888-849-4902,<br/>and we will assist you in understanding your options.</Typography>

            </div>
    )

}

export default NotCleared